<template>
  <div class="explode-panel-box">
    <div class="header-box">
      <div class="title-box">爆炸</div>
      <div class="close-icon-box" @click="closePanel">
        <i class="el-icon-close" />
      </div>
    </div>
    <div class="content-box">
      <div class="option-item-box">
        <div class="label-box">模型选择：</div>
        <div class="select-box">
          <el-select
            class="primary-select"
            popper-class="primary-select-outer"
            size="small"
            v-model="dataSetId"
            filterable
            placeholder="请选择要爆炸的模型"
            @change="onDataSetChange"
          >
            <el-option
              v-for="(item, index) in dataSetList"
              :key="index"
              :label="item.nodeName"
              :value="item.dataSetId"
          /></el-select>
        </div>
      </div>
      <div class="option-item-box">
        <div class="label-box">离散系数：</div>
        <div class="slider-box">
          <el-slider
            input-size="small"
            v-model="centerVirScale"
            :min="1"
            :max="10"
            :step="1"
            @change="onCenterVirScaleChange"
          />
        </div>
        <div class="common-input-box">
          <el-input-number
            size="small"
            :controls="false"
            :min="1"
            :max="10"
            :step="1"
            v-model="centerVirScale"
            @change="onCenterVirScaleChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataSetId: undefined,
      dataSetList: [],

      centerVirScale: 3,

      boneId: 0,
    };
  },
  props: {
    sceneData: Array,
  },
  mounted() {
    this.initDataSetList();
  },
  beforeDestroy() {
    this.resetExplode();
  },
  methods: {
    initDataSetList() {
      let dataSets = this.findAllDataSets();
      let dataSetList = dataSets.filter((el) => el.dataSetType === 0);
      this.dataSetList = dataSetList;
    },
    onDataSetChange(dataSetId) {
      this.resetExplode();

      const BlackHole3D = window.BlackHole3D;
      let resId = dataSetId.replaceAll("-", "");
      let locType = BlackHole3D.RECamDirEm.CAM_DIR_DEFAULT;
      BlackHole3D.Camera.setCamLocateToDataSet(resId, 1.0, locType);

      this.explode(resId, this.centerVirScale);

      let find = this.dataSetList.find((el) => el.dataSetId === dataSetId);
      this.$emit("setCurrentKey", find.nodeId);
    },
    onCenterVirScaleChange(value) {
      let centerVirScale = value;
      let resId = this.dataSetId.replaceAll("-", "");
      this.explode(resId, centerVirScale);
    },
    closePanel() {
      this.$emit("setCurrentKey", null);
      this.$emit("closeExplodePanel");
    },
    explode(dataSetId, centerVirScale) {
      const BlackHole3D = window.BlackHole3D;
      let dataSets = this.findAllDataSets();
      dataSets = dataSets.filter((el) => el.dataSetType === 0);

      this.boneId++;
      BlackHole3D.BIM.setElemToBone(dataSetId, [], this.boneId);
      //获取这批构件的包围盒信息
      let aabbarr = BlackHole3D.BIM.getElemTotalBV(dataSetId, []);
      //通过包围盒信息计算爆炸中心点坐标
      let centerx = (aabbarr[0] + aabbarr[1]) / 2;
      let centery = (aabbarr[2] + aabbarr[3]) / 2;
      let centerz = (aabbarr[4] + aabbarr[5]) / 2;
      //设置全局骨骼的目标方位实现爆炸
      //骨骼的目标方位
      let destLoc = new BlackHole3D.REBoneLoc();
      destLoc.autoScale = [0, 0, 0];
      destLoc.localScale = [1.0, 1.0, 1.0];
      destLoc.localRotate = [0.0, 0.0, 0.0];
      destLoc.centerVirOrig = [centerx, centery, centerz];
      destLoc.centerVirScale = [centerVirScale, centerVirScale, centerVirScale];
      destLoc.centerVirRotate = [0.0, 0.0, 0.0];
      destLoc.centerVirOffset = [0.0, 0.0, 0.0];
      //骨骼方位信息
      let boneLocInfo = new BlackHole3D.REGolBoneLocInfo();
      boneLocInfo.boneId = this.boneId;
      boneLocInfo.interval = 1;
      boneLocInfo.procBatch = 0;
      boneLocInfo.sendPostEvent = false;
      boneLocInfo.destLoc = destLoc;
      BlackHole3D.BIM.setGolElemBoneDestLoc(boneLocInfo);
    },
    resetExplode() {
      window.BlackHole3D.BIM.resetAllGolElemBoneDestLoc();
    },
    findAllDataSets() {
      let allLeafNodes = this.findAllNodeByLevel(this.sceneData, 2);
      let dataSets = allLeafNodes.filter((el) => el.viewStatus !== 2);
      let bimDataSets = dataSets.filter((el) => el.dataSetType === 0);
      return bimDataSets;
    },
    findAllNodeByLevel(data, level) {
      const array = [];

      const traverse = (item) => {
        if (item.nodeType === level) {
          array.push(item);
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach((subNode) => {
            traverse(subNode);
          });
        }
      };

      data.forEach((item) => {
        traverse(item);
      });

      return array;
    },
  },
};
</script>

<style lang="less" scoped>
.explode-panel-box {
  position: absolute;
  bottom: 80px;
  right: 450px;
  width: 300px;
  color: var(--panel-text-color);
  border-radius: 8px;
  background-color: var(--panel-bgColor);
  border: 1px solid var(--panel-border-color);
  box-shadow: var(--base-bg-dark-color31);

  .header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding: 13px 16px;
    border-radius: 8px 8px 0px 0px;
    background: var(--panel-header-bgColor);
    cursor: move;
    border-bottom: 1px solid var(--panel-header-border-color);
    .title-box {
      display: flex;
      align-items: center;
    }
    .close-icon-box {
      width: 24px;
      height: 24px;
      line-height: 24px;
      color: var(--dialog-header-icon-color);
      cursor: pointer;
      border-radius: 4px;

      &:hover {
        background: var(--dialog-header-icon-bgColor);
      }
    }
  }

  .content-box {
    padding: 8px;
    font-size: 14px;

    .option-item-box {
      display: flex;
      align-items: center;
      margin: 4px 0px;

      .select-box {
        flex-grow: 1;
        margin-left: 5px;

        .el-select {
          width: 100%;
        }
      }

      .slider-box {
        flex-grow: 1;
        margin-left: 5px;
        margin-right: 10px;
      }

      .common-input-box {
        width: 60px;
        :deep(.el-input-number--small) {
          width: 100%;

          .el-input__inner {
            padding: 0px 5px;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>